module.exports = __webpack_public_path__ + "img/referto-4.0f27f782.webp";